/**
 * Registered by AzureAuthContext when REACT_APP_BE_URL is set.
 * On backend 401, api.js calls tryRecoverFrom401() once to run MSAL silent
 * acquisition + cookie sync, then retries the request.
 */

let recover = null;

export function setBackend401Recovery(fn) {
  recover = fn;
}

export async function tryRecoverFrom401() {
  if (!recover) return false;
  try {
    return await recover();
  } catch {
    return false;
  }
}
